import React, { Component, useCallback } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import i18n from 'cityads-v3/i18n'
import { amplitudeSendEvent } from 'cityads-v3/utils/counterUtils'
import { ensureArray } from 'cityads-v3/utils/arrayUtils'
import withHooks from 'cityads-v3/decorators/withHooks'
import config from 'cityads-v3/config'

import Button from '@mui/material/Button'
import Dialog from 'cityads-v3/components/Dialog/Dialog'
import Channels from 'cityads-v3/components/Forms/Channels'
import Subaccounts from 'cityads-v3/components/Forms/Subaccounts'

import { getCouponsExportEndpoint, getCoupons } from 'cityads-v3/actions/offers'
import ExportPopupFooter from './ExportPopupFooter'
import classes from './ExportPopup.scss'
import { useCouponFiltersContext } from './CouponFilters.hooks'

@withHooks(props => {
  const getCouponExportUrl = useCouponExportUrl()

  return {
    ...props,
    getCouponExportUrl
  }
})
@withTranslation(['Offers'], { i18n, wait: !!window })
@connect(
  (state, props) => ({
    isMobile: state.app.isMobile,
  })
)
export default class CouponDownloadPopup extends Component {

  static propTypes = {
    buttons: PropTypes.array,
    isMobile: PropTypes.bool,
  }

  state = {
    selectedChannelId: undefined,
    subaccounts: ['']
  }

  getHrefParams() {
    const { selectedChannelId, subaccounts } = this.state

    return {
      channelId: selectedChannelId,
      subaccounts,
    }
  }

  onChannelChange = (id) => {
    this.setState({
      selectedChannelId: id
    })
  }

  onSubaccountsChange = (subaccounts) => {
    this.setState({
      subaccounts
    })
  }

  onClickDownloadButton = (export_type) => {
    export_type = export_type.replace('xlsx', 'xls')

    amplitudeSendEvent('makeActions', 'd-v1-e43', 'goods', 'coupons_export', {
      export_type,
      sub_account: ensureArray(this.state.subaccounts).filter(value => value).length,
    })
  }

  render() {
    const { dispatch, t, tReady, i18n, i18nLoadedAt, open, buttons, isMobile, getCouponExportUrl, ...rest } = this.props
    const hrefParams = this.getHrefParams()

    return (
      <Dialog
        title={t('exports.modalTitle')}
        open={open}
        showLogo={false}
        fullScreen={isMobile}
        childrenClassName={classNames(classes.content, classes.stretchableContent)}
        classes={{
          paper: classes.stretchableDialog
        }}
        {...rest}
      >
        <div className={classes.body}>

          <Channels
            value={this.state.selectedChannelId}
            onChange={this.onChannelChange}
          />

          <Subaccounts
            value={this.state.subaccounts}
            onChange={this.onSubaccountsChange}
            margin="dense"
          />

          <div>
            <Button
              variant="contained"
              color="primary"
              className={classes.downloadButton}
              href={getCouponExportUrl({ ...hrefParams, type: 'xlsx' })}
              onClick={() => this.onClickDownloadButton('xlsx')}
            >
              {t('exports.downloadXls')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.downloadButton}
              href={getCouponExportUrl({ ...hrefParams, type: 'csv' })}
              onClick={() => this.onClickDownloadButton('csv')}
            >
              {t('exports.downloadCsv')}
            </Button>
          </div>

        </div>

        <ExportPopupFooter />
      </Dialog>
    )
  }
}


const useCouponExportUrl = () => {
  const filterContext = useCouponFiltersContext()

  const filters = filterContext.selectedFilters.getFormData()

  if (!filters.is_exclusive) { delete filters.is_exclusive }
  if (!filters.is_personal) { delete filters.is_personal }

  return useCallback(({ type, channelId, subaccounts }) => {
    let url = getCoupons({
      page: 0,
      limit: 0,
      returnAction: true,
      url: getCouponsExportEndpoint({ type }),
      filter: filters
    })

    url += `&channel_id=${channelId}`

    for (let i = 1; i <= config.SUBACCOUNT_MAX_SUBACCOUNTS; i++) {
      url += `&subaccounts[sa${i > 1 ? i : ''}]=${encodeURIComponent(subaccounts[i - 1] || '')}`
    }

    return url
  }, [filters])
}
